module.exports = __webpack_public_path__ + "static/media/ecomienza-white-logo.5aa4414f.png";